<template>
  <div class="login-page">
    <div class="login-page-container">
        <img src="/static/images/logo-white.png" />

        <form class="" v-on:submit.prevent="doLogin">
            <div class="error-message animated fadeIn" v-if="withErrors">
                {{ withErrors }}
            </div>
            <div class="input-group fluid"><input v-model="email" type="email" value="" id="email" placeholder="Your email address"></div>
            <div class="input-group fluid"><input v-model="password" type="password" value="" id="password" placeholder="Password"></div>

            <button 
                class="btn btn-login btn-primary btn-block btn-large"
                v-bind:class="{ loading: isLoading }"
                ><i class="far fa-user"></i> Login to <strong>PageSpy</strong></button>

            <a href="/password-reset">Forgot your password?</a>
        </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login-page',
  data() {
      return {
        isLoading: false,
        withErrors: false,
        email: "",
        password: ""
      }
  },
  methods: {
      doLogin() {
        var $this = this;

        $this.isLoading = true;
        $this.withErrors = false;

          // let's do a request to the server and
        this.$http.post('accounts/auth', { Email: this.email, Password: this.password}).then(function (response) {
            if(response.data.Ok) {
                localStorage.setItem("APIToken", response.data.Account.APIToken)
                localStorage.setItem("AccountID", response.data.Account.ID)

                // $this.$router.push('/')
                window.location = "/";
            } else {
                $this.isLoading = false;
                $this.withErrors = response.data.Message;
            }
        })
      }
  }
}
</script>

<style lang="scss">
.login-page {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background: #092756;
	background: -moz-radial-gradient(0% 100%, ellipse cover, rgba(104,128,138,.4) 10%,rgba(138,114,76,0) 40%),-moz-linear-gradient(top,  rgba(57,173,219,.25) 0%, rgba(42,60,87,.4) 100%), -moz-linear-gradient(-45deg,  #670d10 0%, #092756 100%);
	background: -webkit-radial-gradient(0% 100%, ellipse cover, rgba(104,128,138,.4) 10%,rgba(138,114,76,0) 40%), -webkit-linear-gradient(top,  rgba(57,173,219,.25) 0%,rgba(42,60,87,.4) 100%), -webkit-linear-gradient(-45deg,  #670d10 0%,#092756 100%);
	background: -o-radial-gradient(0% 100%, ellipse cover, rgba(104,128,138,.4) 10%,rgba(138,114,76,0) 40%), -o-linear-gradient(top,  rgba(57,173,219,.25) 0%,rgba(42,60,87,.4) 100%), -o-linear-gradient(-45deg,  #670d10 0%,#092756 100%);
	background: -ms-radial-gradient(0% 100%, ellipse cover, rgba(104,128,138,.4) 10%,rgba(138,114,76,0) 40%), -ms-linear-gradient(top,  rgba(57,173,219,.25) 0%,rgba(42,60,87,.4) 100%), -ms-linear-gradient(-45deg,  #670d10 0%,#092756 100%);
	background: -webkit-radial-gradient(0% 100%, ellipse cover, rgba(104,128,138,.4) 10%,rgba(138,114,76,0) 40%), linear-gradient(to bottom,  rgba(57,173,219,.25) 0%,rgba(42,60,87,.4) 100%), linear-gradient(135deg,  #670d10 0%,#092756 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#3E1D6D', endColorstr='#092756',GradientType=1 );
    border-top: 1px solid #18284a;

    .login-page-container {
        width: 400px;
        margin: 0 auto;
        position: relative;
        top: 10%;
        z-index: 10000;
        color: #fff;
        text-align: center;

        .info-panel {
            background: rgba(0, 0, 0, 0.4);
        }

        .error-message {
            background: #ad3333;
            padding: 5px;
            margin: 8px 0px;
            border-radius: 3px;
            font-size: 13px;
            color: #ffd6d6;
            box-shadow: 0px 0px 10px rgba(84, 17, 16, 0.24), 0px 0px 3px rgba(39, 9, 9, 0.24);
        } 


        form {
            border: none;
            padding: 26px;
            box-shadow: none;
            text-align: center;

            input {
                width: 100%; 
                margin-bottom: 10px; 
                background: rgba(0,0,0,0.3);
                border: none;
                outline: none;
                padding: 10px;
                font-size: 13px;
                color: #fff;
                text-shadow: 1px 1px 1px rgba(0,0,0,0.3);
                border: 1px solid rgba(0,0,0,0.3);
                border-radius: 4px;
                box-shadow: inset 0 -5px 45px rgba(100,100,100,0.2), 0 1px 1px rgba(255,255,255,0.2);
                -webkit-transition: box-shadow .5s ease;
                -moz-transition: box-shadow .5s ease;
                -o-transition: box-shadow .5s ease;
                -ms-transition: box-shadow .5s ease;
                transition: box-shadow .5s ease;

                &:-webkit-autofill {
                    background-color: #000 !important;
                    // background-image: none !important;
                    color: #fff !important;
                }

                &:focus {
                    box-shadow: inset 0 -5px 45px rgba(100,100,100,0.4), 0 1px 1px rgba(255,255,255,0.2);
                }
            }

            input:-webkit-autofill,
            input:-webkit-autofill:hover, 
            input:-webkit-autofill:focus
            input:-webkit-autofill, 
            textarea:-webkit-autofill,
            textarea:-webkit-autofill:hover
            textarea:-webkit-autofill:focus,
            select:-webkit-autofill,
            select:-webkit-autofill:hover,
            select:-webkit-autofill:focus {
                border: 1px solid #8086ff;
                -webkit-text-fill-color: #bfceea;
                -webkit-box-shadow: 0 0 0px 1000px #000 inset;
                transition: background-color 5000s ease-in-out 0s;
            }

            .btn { display: inline-block; *display: inline; *zoom: 1; padding: 4px 10px 4px; margin-bottom: 0; font-size: 13px; line-height: 18px; color: #333333; text-align: center;text-shadow: 0 1px 1px rgba(255, 255, 255, 0.75); vertical-align: middle; background-color: #f5f5f5; background-image: -moz-linear-gradient(top, #ffffff, #e6e6e6); background-image: -ms-linear-gradient(top, #ffffff, #e6e6e6); background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#ffffff), to(#e6e6e6)); background-image: -webkit-linear-gradient(top, #ffffff, #e6e6e6); background-image: -o-linear-gradient(top, #ffffff, #e6e6e6); background-image: linear-gradient(top, #ffffff, #e6e6e6); background-repeat: repeat-x; filter: progid:dximagetransform.microsoft.gradient(startColorstr=#ffffff, endColorstr=#e6e6e6, GradientType=0); border-color: #e6e6e6 #e6e6e6 #e6e6e6; border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25); border: 1px solid #e6e6e6; -webkit-border-radius: 4px; -moz-border-radius: 4px; border-radius: 4px; -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05); -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05); box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05); cursor: pointer; *margin-left: .3em; }
            .btn:hover, .btn:active, .btn.active, .btn.disabled, .btn[disabled] { background-color: #e6e6e6; }
            .btn-large { padding: 9px 14px; font-size: 15px; line-height: normal; -webkit-border-radius: 5px; -moz-border-radius: 5px; border-radius: 5px; }
            .btn:hover { color: #333333; text-decoration: none; background-color: #e6e6e6; background-position: 0 -15px; -webkit-transition: background-position 0.1s linear; -moz-transition: background-position 0.1s linear; -ms-transition: background-position 0.1s linear; -o-transition: background-position 0.1s linear; transition: background-position 0.1s linear; }
            .btn-primary, .btn-primary:hover { text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25); color: #ffffff; }
            .btn-primary.active { color: rgba(255, 255, 255, 0.75); }
            .btn-primary { background-color: #4a77d4; background-image: -moz-linear-gradient(top, #6eb6de, #4a77d4); background-image: -ms-linear-gradient(top, #6eb6de, #4a77d4); background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#6eb6de), to(#4a77d4)); background-image: -webkit-linear-gradient(top, #6eb6de, #4a77d4); background-image: -o-linear-gradient(top, #6eb6de, #4a77d4); background-image: linear-gradient(top, #6eb6de, #4a77d4); background-repeat: repeat-x; filter: progid:dximagetransform.microsoft.gradient(startColorstr=#6eb6de, endColorstr=#4a77d4, GradientType=0);  border: 1px solid #3762bc; text-shadow: 1px 1px 1px rgba(0,0,0,0.4); box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.5); }
            .btn-primary:hover, .btn-primary:active, .btn-primary.active, .btn-primary.disabled, .btn-primary[disabled] { filter: none; background-color: #4a77d4; }
            .btn-block { width: 100%; display:block; }
            .btn.loading { text-shadow: none; background: #4a77d4; }
        }

        a:link {
            color: rgba(255, 255, 255, 0.39);
            text-align: center;
            text-shadow: 0px 1px 1px #0c0c0c;
            font-size: 12px;
        }

        h1 {
            text-align: center;
            font-weight: 300;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/LoginPage.vue